import type {
	createUserInput,
	getAllUsersInput,
	getUserInput,
	getUserWalletInput,
	putUserWalletInfoInput,
	updateUserInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetAllUsers: getAllUsersInput;
	useCreateUser: createUserInput;
	useGetUser: getUserInput;
	useUpdateUser: updateUserInput;
	useGetUserWallet: getUserWalletInput;
	usePutUserWalletInfo: putUserWalletInfoInput;
}

const USERS_SERVICE_KEYS = createReactQueryKeys<KeyTypes>("users", [
	"useGetAllUsers",
	"useCreateUser",
	"useGetUser",
	"useUpdateUser",
	"useGetUserWallet",
	"usePutUserWalletInfo",
]);

export { USERS_SERVICE_KEYS };
